module.exports = __webpack_public_path__ + "img/202412_skinmask.741ec3ae.jpg";